import { revalidarCatalogosAposEscrita } from '@/integracoes/src-next/catalogos/revalidar-apos-escrita'
import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'
import { modulosTextos, submodulosTextos } from './constantes';
import { validarCondicaoShow } from './utilitarios';

import {
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils.store'

import { API } from 'src/services'

const moduleGroups = {
  // aba permissões - coluna esquerda
  estruturaDaEmpresa: [
    'cadastros',
    'appkey',
    'auditoriadeintegracoes',
    'employer',
    'company',
    'compemployee',
    'dadoscadastraisdoempregado',
    'dadosdetrabalhodoempregado',
    'escaladoempregado',
    'configuracoesdepontoebeneficiosdoempregado',
    'camposopcionaisdoempregado',
    'camposcustomizaveisdoempregado',
    'camposcustomizaveisdafolha',
    'user',
    'role',
    'rolegroup',
    'usergroup',
    'exportfiles',
    'alteracoesmultiplas',
    'financeiro'
  ],
  calendarioDeTrabalho: [
    'journey',
    'routine',
    'holidaysCalendar',
    'feriaseafastamento',
  ],
  gestaoDePontoParticipativa: [
    'regradetravamento',
    'objectapprovalrules',
    'objectapprovalsrequest',
    'aprovacaoemlotesolicitacoes',
    'unlockerask',
    'lockconfirmation',
    'locker',
    'aprovacaoarquivo',
  ],
  controleDeCustos: [
    'notification',
    'notificationrules',
    'acompanhamentodiario',
    'oncall',
    'faroldodp'
  ],
  ferias: [
    'regrasdeferias'
  ],

  // aba permissões - coluna direita
  registroDePontos: [
    'deviceregister',
    'showtimelogs',
    'manage',
  ],
  reducaoDeRiscos: [
    'biometric',
    'controledeacesso',
    'userblock',
  ],
  calculos: [
    'customrules',
    'dayjourney',
    'verificardia',
    'timemeasurements',
    'sumtimemeasurements',
    'arbitrarytms',
    'workhourbankrules',
    'workhourbankcloser',
    'workhourbankobjects',
    'workhourbankwindow',
    'workhourbankauth',
    'transferenciadeapontamentos'
  ],
  correcoesTratamentoDePonto: [
    'faketimelog',
    'edittimelogkind',
    'ignoretimelog',
    'autocorrect',
    'groupscomment',
    'trabalhoremoto',
    'abstractjustify',
    'justify',
    'suspension',
    'absence',
    'reason',
    'problems',
    'fastregister',
    'unilateralcloses',
    'unlocker',
    'autocomplete',
    'timelog'
  ],
  controleDeEstacoes: [
    'controledeestacoesestacoes',
    'controledeestacoesinstalacao',
    'controledeestacoesconfiguracao'
  ],

  // aba acessos - coluna esquerda
  relatorios: [
    'r01', 'r02', 'r03', 'r05', 'r06', 'r08', 'r09', 'r10',
    'r12', 'r13', 'r14', 'r15', 'r16', 'r17', 'r18', 'r19', 'r20',
    'r21', 'r22', 'r25', 'r26', 'r27', 'r28', 'r29', 'r30',
    'r31', 'r35', 'r36', 'r37', 'r38', 'relatoriodeauditoria', 'importafd',
    'relatoriodebaixasagendadas', 'relatoriodepontosconsiderados'
  ],

  // aba acessos - coluna direita
  importadores: [
    'i01', 'i02', 'i03', 'i04', 'importadoresgestaoweb'
  ],
  exportadores: [
    'e01', 'e02', 'e03', 'e04', 'e05', 
    'e06', 'e07', 'e08', 'e09', 'e10', 
    'e11', 'e12', 'e13'
  ],
}

// usado apenas para mapear a legenda
const subModuleGroups = {
  compemployee: [
    'dadoscadastraisdoempregado',
    'dadosdetrabalhodoempregado',
    'escaladoempregado',
    'configuracoesdepontoebeneficiosdoempregado',
    'camposopcionaisdoempregado',
    'camposcustomizaveisdoempregado',
    'camposcustomizaveisdafolha',
  ],
  journey: [
    'segmentacaodevisualizacaojornada'
  ],
  routine: [
    'segmentacaodevisualizacaoescala'
  ]
}

function fromBackend(roleGroup) {
  return {
    id: roleGroup.id,
    name: roleGroup.name,
    description: roleGroup.description,
    kind: roleGroup.kind,
    roles: roleGroup.roles
  }
}

function toBackEnd(state) {
  function formatRoles(s) {
    const extractRoles = (acc, m) => {
      if (m.actions.get) acc.push({ module: m.module, filter: s.kind, action: 'get' })
      if (m.actions.post) acc.push({ module: m.module, filter: s.kind, action: 'post' })
      if (m.actions.delete && (!m.actions.acoesDisponiveis || m.actions.acoesDisponiveis.includes('delete'))) acc.push({ module: m.module, filter: s.kind, action: 'delete' })
      if (m.subModules.length > 0) {
        m.subModules.forEach(subModule => {
          if (subModule.actions.get) acc.push({ module: subModule.module, filter: s.kind, action: 'get' })
          if (subModule.actions.post) acc.push({ module: subModule.module, filter: s.kind, action: 'post' })
          if (subModule.actions.delete && (!subModule.actions.acoesDisponiveis || subModule.actions.acoesDisponiveis.includes('delete'))) acc.push({ module: subModule.module, filter: s.kind, action: 'delete' })
        })
      }
      return acc
    }
    const estruturaDaEmpresa = s.estruturaDaEmpresa.reduce(extractRoles, [])
    const reducaoDeRiscos = s.reducaoDeRiscos.reduce(extractRoles, [])
    const calendarioDeTrabalho = s.calendarioDeTrabalho.reduce(extractRoles, [])
    const correcoesTratamentoDePonto = s.correcoesTratamentoDePonto.reduce(extractRoles, [])
    const registroDePontos = s.registroDePontos.reduce(extractRoles, [])
    const controleDeCustos = s.controleDeCustos.reduce(extractRoles, [])
    const ferias = s.ferias.reduce(extractRoles, [])
    const gestaoDePontoParticipativa = s.gestaoDePontoParticipativa.reduce(extractRoles, [])
    const calculos = s.calculos.reduce(extractRoles, [])
    const controleDeEstacoes = s.controleDeEstacoes.reduce(extractRoles, [])
    const relatorios = s.relatorios.reduce(extractRoles, [])
    const exportadores = s.exportadores.reduce(extractRoles, [])
    const importadores = s.importadores.reduce(extractRoles, [])

    return [
      ...estruturaDaEmpresa,
      ...reducaoDeRiscos,
      ...calendarioDeTrabalho,
      ...correcoesTratamentoDePonto,
      ...registroDePontos,
      ...controleDeCustos,
      ...ferias,
      ...gestaoDePontoParticipativa,
      ...calculos,
      ...controleDeEstacoes,
      ...relatorios,
      ...exportadores,
      ...importadores
    ]
  }

  const request = {
    name: state.name,
    description: state.description,
    kind: state.kind,
    roles: formatRoles(state)
  }

  if (state.id) request.id = state.id

  return request
}

function defaultState() {
  return {
    loading: false,
    roleDetails: null,
    options: null,
    estruturaDaEmpresa: null,
    reducaoDeRiscos: null,
    calendarioDeTrabalho: null,
    correcoesTratamentoDePonto: null,
    registroDePontos: null,
    controleDeCustos: null,
    gestaoDePontoParticipativa: null,
    calculos: null,
    ferias: null,
    controleDeEstacoes: null,

    // Relatórios
    relatorios: null,
    exportadores: null,
    importadores: null,

    emEdicaoPossuiRelatoriosERegistrosAtivo: false,

    // object to back end
    id: null,
    name: '',
    description: '',
    kind: 'all'
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState()),
  permissaoGeralRelatorios (state) {
    const moduloDeRelatorios = state.estruturaDaEmpresa?.find(modulo => modulo.module === 'exportfiles')
    return moduloDeRelatorios
  },
  possuiOpcaoGerarRelatorioAtiva(_, getters) {
    return getters.permissaoGeralRelatorios?.actions.post
  }
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState(state) {
    resetarParaEstadoInicial(state, defaultState())
  },
  setFromState(state, { ...roleGroup }) {
    const moduloDeRelatoriosERegistros = roleGroup.roles.some(permissao => permissao.name.includes('exportfiles_post'))
    state.emEdicaoPossuiRelatoriosERegistrosAtivo = moduloDeRelatoriosERegistros

    roleGroup.roles.forEach(r => {
      if (r?.subpermissao) {
        const moduloPai = r.permissaoPai.split('_')[0]

        const group = Object.keys(moduleGroups)
          .filter(m => moduleGroups[m].includes(moduloPai))
        if (group.length === 1) {
          const groupName = group[0]
          const m = state[groupName].find(m => m.module === moduloPai)
          const submodulo = m.subModules.find(e => e.module === r.module)
          if (submodulo) {
            submodulo.actions[r.action] = true
          }
        }
      } else {
        const group = Object.keys(moduleGroups)
          .filter(m => moduleGroups[m].includes(r.module))
        if (group?.length === 1) {
          const groupName = group[0]
          const m = state[groupName].find(m => m?.module === r?.module)
          if (m) {
            if (!m.actions.acoesDisponiveis || m.actions.acoesDisponiveis.includes(r.action)) {
              m.actions[r.action] = true
            }
          }
        }
      }
    })

    delete roleGroup.roles
    Object.assign(state, roleGroup)
  },
  formatPermissions(state, payload) {
    const dadosApi = payload

    const objectFormat = m => {
      const acoesDisponiveis = m === 'controledeestacoesconfiguracao' ? ['get', 'post'] : ['get', 'post', 'delete']
      return {
        module: m,
        moduleName: modulosTextos[m] || dadosApi.modulesPrettifier[m],
        exibir: validarCondicaoShow(m),
        actions: {
          get: false,
          post: false,
          delete: false,
          acoesDisponiveis
        },
        kind: 'mine',
        subModules: (subModuleGroups[m] || []).map(submodule => ({
          actions: {
            get: false,
            post: false,
            delete: false
          },
          module: submodule,
          exibir: validarCondicaoShow(submodule),
          kind: 'mine',
          moduleName: submodulosTextos[submodule] || dadosApi.submodulosPrettifier[submodule[1]]
        }))
      }
    }

    const ordenarEFiltrarModulos = nomeDoGrupo => {
      const modulosOrdenados = moduleGroups[nomeDoGrupo]; 
      
      const modulosOrdenadosFiltrados =
        modulosOrdenados.map(chaveDoModulo => formatedModules.find(formattedModule => formattedModule.module === chaveDoModulo))
          .filter(modulo => modulo && modulo.exibir)

      // Remove submódulos que não devem ser exibidos, alterando o próprio `subModules`
      // do módulo (em vez de retornar um array separado só com subModules).
      return modulosOrdenadosFiltrados.map(modulo => ({
        ...modulo,
        subModules: (modulo.subModules || []).filter(submodulo => submodulo && submodulo.exibir)
      }))
    }


    const formatedModules = dadosApi.modules.map(objectFormat)
    state.estruturaDaEmpresa = ordenarEFiltrarModulos('estruturaDaEmpresa')
    state.reducaoDeRiscos = ordenarEFiltrarModulos('reducaoDeRiscos')
    state.calendarioDeTrabalho = ordenarEFiltrarModulos('calendarioDeTrabalho')
    state.correcoesTratamentoDePonto = ordenarEFiltrarModulos('correcoesTratamentoDePonto')
    state.registroDePontos = ordenarEFiltrarModulos('registroDePontos')
    state.controleDeCustos = ordenarEFiltrarModulos('controleDeCustos')
    state.ferias = ordenarEFiltrarModulos('ferias')
    state.gestaoDePontoParticipativa = ordenarEFiltrarModulos('gestaoDePontoParticipativa')
    state.calculos = ordenarEFiltrarModulos('calculos')
    state.controleDeEstacoes = ordenarEFiltrarModulos('controleDeEstacoes')
    state.relatorios = ordenarEFiltrarModulos('relatorios')
    state.exportadores = ordenarEFiltrarModulos('exportadores')
    state.importadores = ordenarEFiltrarModulos('importadores')
  },
  loading(state, payload) {
    state.loading = payload
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadRoleGroups({ commit }, roleGroupId) {
    commit('loading', true)

    const api = await API.roleGroup.get({ id: roleGroupId })

    commit('setFromState', {
      ...fromBackend(api.data.success[0])
    })
    commit('loading', false)
  },
  async loadRoleDetails({ commit }) {
    const api = await API.roleDetails.get()

    commit('roleDetails', api.data.success)
    commit('formatPermissions', api.data.success)
  },
  async salvarGrupoDePermissoes({ state, getters, dispatch }) {
    if (!getters.possuiOpcaoGerarRelatorioAtiva) {
      dispatch('definirPermissaoDeTodosOsRelatoriosERegistrosDeAcordoComPermissaoGeral', false)
    }

    const grupoDePermissoes = toBackEnd(state)

    if (state.id) {
      await API.roleGroup.save({ id: state.id }, grupoDePermissoes)
    } else {
      await API.roleGroup.save(grupoDePermissoes)
    }
    revalidarCatalogosAposEscrita(dispatch, ['roleGroups'])
  },
  definirPermissaoDeTodosOsRelatoriosERegistrosDeAcordoComPermissaoGeral({ state, commit }, permissaoGeral) {
    const relatorios = state.relatorios
    const exportadores = state.exportadores
    const importadores = state.importadores
    const definirPermissoDeAcordoComPermissaoGeral = (relatorio) => {
      relatorio.actions.get = permissaoGeral
      relatorio.actions.post = permissaoGeral
      relatorio.actions.delete = permissaoGeral
    }

    relatorios.forEach(definirPermissoDeAcordoComPermissaoGeral)
    exportadores.forEach(definirPermissoDeAcordoComPermissaoGeral)
    importadores.forEach(definirPermissoDeAcordoComPermissaoGeral)

    commit('relatorios', relatorios)
    commit('exportadores', exportadores)
    commit('importadores', importadores)
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
